<template>
  <div style="width:100vw;display:flex;justify-content:space-around;background-color: #ffc75f;">
    <div style="max-width:350px;text-align: center;magin:auto; height:100vh;background-color:#fff3;">
    <h2 style=" padding:10px;" >The Loop Volume Control</h2>
      <div style="text-align: center;font-size:20px">Volume: {{deviceVolume}}</div>
     
      <div style="display:flex;justify-content:space-around; padding:10px;">
        <div>
       <v-btn @click="volumeDown()"><v-icon dark left>volume_down</v-icon>-</v-btn>
       <v-btn @click="volumeUp()"><v-icon dark left>volume_up</v-icon>+</v-btn>
       </div>
      
       </div>
         <v-btn @click="volumeReset(70)"><v-icon dark left>volume_up</v-icon>MED</v-btn>
         <v-btn @click="volumeReset(80)"><v-icon dark left>volume_up</v-icon>MED HIGH</v-btn>
        <div style="padding-top:10px;">*default volume is ~ 7.3</div>
         <v-btn @click="volumeReset(52)"><v-icon dark left>volume_up</v-icon>Reset</v-btn>
         <div>
        NB. Wait for the volume to update between button presses. The command needs to go to the loop and then back again with the updated value.<br>
        
        </div>
        
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deviceVolume:"~",
    };
  },
  mounted() {
   if(this.status){
        if(this.status.deviceVolume){
          this.deviceVolume=parseFloat(this.status.deviceVolume);
        }
      }
  },
  computed: {
   status () {
       //return false;
       return this.$store.getters.getStatus
     },
     natVol(){
       return Math.floor(Math.pow(10,this.deviceVolume/10)*10)
     }
  },

  methods: {
    volumeUp(){
      this.$store.dispatch('sendCommand', {cmd:'volumeUp'});
    },
    volumeDown(){
      //this.$store.dispatch('setControlsVolume', 90);
      this.$store.dispatch('sendCommand', {cmd:'volumeDown'});


    },
    volumeReset(vol){
        this.$store.dispatch('setControlsVolume',vol)
    }
   
  },
  watch:{
    status (value) {
      
      console.log("HAVE status",value);
      if(value.deviceVolume){
        this.deviceVolume=parseFloat(value.deviceVolume).toFixed(1);
      }
    },
  }
};
</script>

<style >
main {
  height: 100%;
}
</style>
<style scoped>
.timeText {
  position: fixed;
  bottom: 0px;
  right: 0px;
  color: #fff;
  font-size: 30px;
  font-family: "VT323", monospace;
  text-shadow: 0px 0 5px #000000;
  line-height: 30px;
  background-color: #00000077;
  text-align: right;
  padding-right: 30px;
  padding-left: 100px;
  width: auto;
  z-index: 1000;
}
.top {
  top: 0px;
  bottom: auto;
}
.left {
  left: 0px;
  right: auto;
}
.camCaption {
  text-align: center;
  position: relative;
  color: #fff;
  font-size: 40px;
  width: 100%;
  top: 50%;
}
.screenColor {
  background-color: #000;
  height: 100%;
  background-size: contain;
  background-position: center;
}
.screenCover {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #000;
}
.fade {
  opacity: 1;
  transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -webkit-transition: opacity 1s ease-in-out;
}
.fade2 {
  opacity: 1;
  transition: opacity 1s ease-in-out;
  -moz-transition: opacity 1s ease-in-out;
  -webkit-transition: opacity 1s ease-in-out;
}

.zoom {
  animation-name: pulse_animation;
  animation-duration: 10000ms;
}
@keyframes pulse_animation {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Play/volume.vue